export default __webpack_public_path__ + "static/media/Boriyamal-Island.d9d923c9.jpg";